import {createSelector} from '@ngrx/store';

import {IAppState} from '@app/core/store/state/app.state';
import {ISessionState} from '@app/core/store/state/session.state';

const _selectSession = (state: IAppState) => state.session;

export const selectUser = createSelector(
	_selectSession,
	(state: ISessionState) => state.user,
);
export const selectTenant = createSelector(
	_selectSession,
	(state: ISessionState) => state.tenant,
);
export const selectTenants = createSelector(
	_selectSession,
	(state: ISessionState) => state.tenants,
);
export const selectDepartment = createSelector(
	_selectSession,
	(state: ISessionState) => state.department,
);
export const selectDepartments = createSelector(
	_selectSession,
	(state: ISessionState) => state.departments,
);
export const selectIsLoadingSession = createSelector(
	_selectSession,
	(state: ISessionState) => state.isLoading,
);
export const selectRegistrationComplete = createSelector(
	_selectSession,
	(state: ISessionState) => state.registrationComplete,
);
export const selectHubChain = createSelector(
	_selectSession,
	(state: ISessionState) => state.hub_chain,
);
